import React from 'react';
import '../../../../styles/Commons.css';
import {Card, Col, Row, Tag} from "antd";
import Rebut from "../../../../model/multilleure/rebuts/Rebut";

interface element {
    element: Rebut
}

const PlantillaLista = (ele: element) => {


    return (
        <Card bordered={true}>
            <Row gutter={16}>
                <Col className="gutter-row" span={4}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Número de rebut</b>
                        </Col>
                        <Col className="gutter-row">
                            <div>{ele.element.id}</div>
                        </Col>
                    </Row>
                </Col>
           
                <Col className="gutter-row" span={4}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Pagador</b>
                        </Col>
                        <Col className="gutter-row">
                            <div>{ele.element.pagador}</div>
                        </Col>
                    </Row>
                </Col>
                  <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>IBAN</b>
                        </Col>
                        <Col className="gutter-row">
                            <div>{ele.element.iban}</div>
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={4}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Quota</b>
                        </Col>
                        <Col className="gutter-row">
                            <div>{ele.element.quota}</div>
                        </Col>
                        <Col className="gutter-row">
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={4}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Data Alta</b>
                        </Col>
                        <Col className="gutter-row">
                            <Tag>
                                {ele.element.alta}
                            </Tag>
                        </Col>
                    </Row>
                </Col>
                
            </Row>
            <br/>
            <Row gutter={16}>
                <Col className="gutter-row" span={8}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Observacions</b>
                        </Col>
                        <Col className="gutter-row">
                            <div dangerouslySetInnerHTML={{__html: ele.element.observacions}}/>
                        </Col>
                    </Row>
                </Col>
                
                
                <Col className="gutter-row" span={10}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Concepte</b>
                        </Col>
                        <Col className="gutter-row">
                            <div dangerouslySetInnerHTML={{__html: ele.element.concepte}}/>
                        </Col>
                    </Row>
                </Col>

                <Col className="gutter-row" span={4}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Data d'inscripció</b>
                        </Col>
                        <Col className="gutter-row">
                            <Tag>{ele.element.finalitzacio}</Tag>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Card>
    );
};
export default PlantillaLista;
